export default __webpack_public_path__ + "static/media/6.23a55f1b.jpg";